import { Comment, Fragment, type Slot, type VNode } from 'vue'

function rendersNode(node: VNode): boolean {
  if (node.type === Comment) return false
  if (node.type === Fragment && Array.isArray(node.children)) {
    return (node.children as VNode[]).some(rendersNode)
  }
  return true
}

/** True when the slot renders at least one node other than a `v-if` comment. Call it from the template only. */
export function slotRenders(slot: Slot | undefined): boolean {
  return (slot?.() ?? []).some(rendersNode)
}
